/**
 * @generated SignedSource<<c76aaea20397451a1d2f766442600f49>>
 * @relayHash 5a7885d48edbd07f426ed44bae60ca27
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID efc74b1f01dbd8f8e9022d6c16011704f8ccfd1fb9956ac90306960103e88567

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { decomposedStoryPointEstimateFieldQuery } from './decomposedStoryPointEstimateFieldQuery.graphql';

const node: PreloadableConcreteRequest<decomposedStoryPointEstimateFieldQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "efc74b1f01dbd8f8e9022d6c16011704f8ccfd1fb9956ac90306960103e88567",
    "metadata": {},
    "name": "decomposedStoryPointEstimateFieldQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
